export default __webpack_public_path__ + "static/media/greenpattern.c86c862c.png";